<template>

  <RiepilogoGettoni />
 
</template>

<script>
import RiepilogoGettoni from '../components/pratiche/RiepilogoGettoni.vue'

export default {
  pageName: '',
  components: {
    RiepilogoGettoni

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
